import { WOWPark } from "./assets/images";
import { ParkLogo } from "./assets/images";
import { Game1 } from "./assets/images";
import { Game2 } from "./assets/images";
import { Game3 } from "./assets/images";
import { Game4 } from "./assets/images";
import { Game5 } from "./assets/images";
import { ThumbnailAqua } from "./assets/images";
export const ParksData = [
  {
    id: 1,
    title: "WOW Park",
    tagline: "State-of-the-art indoor entertainment park",
    image: WOWPark,
  },
  {
    id: 2,
    title: "Megapolis",
    tagline: "Immerse yourself in a world of fun, thrill, and adventure.",
    image: WOWPark,
  },
  {
    id: 3,
    title: "Baladna Park",
    tagline: "Gateway to a peaceful Nature Wonderland!",
    image: WOWPark,
  },
  {
    id: 4,
    title: "KidzMondo",
    tagline:
      "International edutainment concept offering a unique & fun indoor theme park",
    image: WOWPark,
  },
  {
    id: 5,
    title: "Rush Action Park",
    tagline: "The park boasts a plethora of thrilling attractions & activities",
    image: WOWPark,
  },
  {
    id: 6,
    title: "Minipolis",
    tagline: "Fun, Socialize, Learn and Compete ",
    image: WOWPark,
  },
  {
    id: 7,
    title: "Lusail Winter Wonderland",
    tagline: "The ultimate entertainment and lifestyle celebration.",
    image: WOWPark,
  },
  {
    id: 8,
    title: "Aqua Zone",
    tagline: "Enjoy the full Aqua Zone water sports experience",
    image: WOWPark,
  },
];

export const TicketData = [
  {
    id: 1,
    title: "Baby - Below 1 year old",
    cost: "0",
  },
  {
    id: 2,
    title: "Toddler - 1 to 4 year old",
    cost: "90",
  },
  {
    id: 3,
    title: "Kid - 4-14 years old",
    cost: "135",
  },
  {
    id: 4,
    title: "Adult - Above 14 years old",
    cost: "90",
  },
  {
    id: 5,
    title: "Special needs",
    cost: "85",
  },
];

export const VisitingHour = [
  {
    id: 1,
    day: "Saturday to Thursday",
    hr: "10:00 AM - 05:30 PM",
  },
];
export const AquaGamesList = [
  {
    id: 1,
    title: "JET SKI",
    values: [
      {
        id: 1,
        image: Game1,
        subTitle: "JET SKI GTI 130 HP",
        riderNo: "Single and Twin Rider",
        amount: ["15 Min 250Qar", "35 Min 250Qar", "60 Min 250Qar"],
      },
      {
        id: 2,
        image: Game2,
        subTitle: "JET SKI GTI 130 HP",
        riderNo: "Single and Twin Rider",
        amount: ["15 Min 250Qar", "35 Min 250Qar", "60 Min 250Qar"],
      },
    ],
  },
  {
    id: 2,
    title: "FLY BOARD",
    values: [
      {
        id: 1,
        image: Game3,
        subTitle: "JET SKI GTI 130 HP",
        riderNo: "Single and Twin Rider",
        amount: ["15 Min 250Qar", "35 Min 250Qar", "60 Min 250Qar"],
      },
    ],
  },
  {
    id: 3,
    title: "WAKE BOARD",
    values: [
      {
        id: 1,
        image: Game4,
        subTitle: "JET SKI GTI 130 HP",
        riderNo: "Single and Twin Rider",
        amount: ["15 Min 250Qar", "35 Min 250Qar", "60 Min 250Qar"],
      },
    ],
  },
  {
    id: 4,
    title: "KAYAK",
    values: [
      {
        id: 1,
        image: Game5,
        subTitle: "JET SKI GTI 130 HP",
        riderNo: "Single and Twin Rider",
        amount: ["15 Min 250Qar", "35 Min 250Qar", "60 Min 250Qar"],
      },
      {
        id: 2,
        image: Game5,
        subTitle: "JET SKI GTI 130 HP",
        riderNo: "Single and Twin Rider",
        amount: ["15 Min 250Qar", "35 Min 250Qar", "60 Min 250Qar"],
      },
    ],
  },
  {
    id: 4,
    title: "INFLATABLES",
    values: [
      {
        id: 1,
        image: Game5,
        subTitle: "JET SKI GTI 130 HP",
        riderNo: "Single and Twin Rider",
        amount: ["15 Min 250Qar", "35 Min 250Qar", "60 Min 250Qar"],
      },
      {
        id: 2,
        image: Game3,
        subTitle: "JET SKI GTI 130 HP",
        riderNo: "Single and Twin Rider",
        amount: ["15 Min 250Qar", "35 Min 250Qar", "60 Min 250Qar"],
      },
      {
        id: 3,
        image: Game2,
        subTitle: "JET SKI GTI 130 HP",
        riderNo: "Single and Twin Rider",
        amount: ["15 Min 250Qar", "35 Min 250Qar", "60 Min 250Qar"],
      },
    ],
  },
];
export const truncatedText =
  "KidzMondo Doha is an international edutainment concept, designed to provide a complete solution for children in a unique indoor theme park. It is a kid-sized city that is created with the intention to impart knowledge through playful learning. Children will experience age-appropriate activities in a dynamic and safe surrounding.";

export const AquaDropdownData = [
  {
    id: 1,
    value: "10:00AM - 11:00PM",
  },
  {
    id: 2,
    value: "11:00AM - 12:00PM",
  },
  {
    id: 3,
    value: "12:00AM - 1:00PM",
  },
  {
    id: 4,
    value: "1:00PM - 2:00PM",
  },
];

export const AquaDropdownDurationData = [
  {
    id: 1,
    value: "15 min",
    price: "200",
  },
  {
    id: 2,
    value: "35 min",
    price: "250",
  },
  {
    id: 3,
    value: "45 min",
    price: "300",
  },
];

export const PurchaseDropdownData = [
  {
    id: 1,
    value: "Upcoming Reservations",
  },
  {
    id: 2,
    value: "Restuarant Bookings",
  },
  {
    id: 3,
    value: "Entertainment Tickets",
  },
  {
    id: 4,
    value: "Reservation History",
  },
];
export const PurchasedProductsData = [
  {
    id: 1,
    image: ThumbnailAqua,
    ticketId: "aaaaaa",
    visitDetails: "23 Oct 2023(10AM-11AM)",
    products: "Jet Ski GTI 130 HP",
    duration: "15 min",
    status: "UPCOMING",
  },
  {
    id: 2,
    image: ThumbnailAqua,
    ticketId: "bbbbbb",
    visitDetails: "23 Oct 2023(10AM-11AM)",
    products: "Jet Ski GTI 130 HP",
    duration: "15 min",
    status: "UPCOMING",
  },
  {
    id: 3,
    image: ThumbnailAqua,
    ticketId: "cccccc",
    visitDetails: "23 Oct 2023(10AM-11AM)",
    products: "Jet Ski GTI 130 HP",
    duration: "15 min",
    status: "UPCOMING",
  },
  {
    id: 4,
    image: ThumbnailAqua,
    ticketId: "dddddd",
    visitDetails: "23 Oct 2023(10AM-11AM)",
    products: "Jet Ski GTI 130 HP",
    duration: "15 min",
    status: "UPCOMING",
  },
  {
    id: 5,
    image: ThumbnailAqua,
    ticketId: "eeeeee",
    visitDetails: "23 Oct 2023(10AM-11AM)",
    products: "Jet Ski GTI 130 HP",
    duration: "15 min",
    status: "UPCOMING",
  },
  {
    id: 6,
    image: ThumbnailAqua,
    ticketId: "ffffff",
    visitDetails: "23 Oct 2023(10AM-11AM)",
    products: "Jet Ski GTI 130 HP",
    duration: "15 min",
    status: "UPCOMING",
  },
  {
    id: 6,
    image: ThumbnailAqua,
    ticketId: "ffffff",
    visitDetails: "23 Oct 2023(10AM-11AM)",
    products: "Jet Ski GTI 130 HP",
    duration: "15 min",
    status: "UPCOMING",
  },
];

export const Months = [
  "jan",
  "feb",
  "mar",
  "apr",
  "may",
  "jun",
  "jul",
  "aug",
  "sep",
  "oct",
  "nov",
  "dec",
];

export const segments = [
  "1",
  "2",
  "3",
  "4",
  // "5",
  // "6",
  // "7",
  // "8",
  // "9",
  // "10",
  // "11",
  // "12",
  // "13",
  // "14",
  // "15",
  // "16",
  // "17",
  // "18",
];
export const segColors = [
  "#FFD029",
  "#55038D",
  "#FFD029",
  "#55038D",
  "#FFD029",
  "#55038D",
  "#FFD029",
  "#55038D",
  "#FFD029",
  "#55038D",
  "#FFD029",
  "#55038D",
  "#FFD029",
  "#55038D",
  "#FFD029",
  "#55038D",
  "#FFD029",
  "#55038D",
];
